import GoodsReturnManage from "./GoodsReturnManage";

export default GoodsReturnManage;
